import * as React from 'react'

import { cn } from '../../lib/utils'

type CheckboxProps = React.ComponentProps<'input'> & {
  onCheckedChange?: (checked: boolean) => void
}

function Checkbox({ className, onCheckedChange, ...props }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      data-slot="checkbox"
      className={cn(
        'border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 rounded-sm border bg-transparent shadow-xs transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
      onChange={(event) => {
        onCheckedChange?.(event.target.checked)
        props.onChange?.(event)
      }}
    />
  )
}

export { Checkbox }
